import { Button, EmptyState } from '@paguz/ui';
import { Link } from '@tanstack/react-router';
import { CompassIcon, ShieldOffIcon } from 'lucide-react';

export function ForbiddenPage() {
  return (
    <EmptyState
      className="mt-16"
      icon={<ShieldOffIcon />}
      title="Tu rol no tiene acceso a esta sección"
      description="Si necesitas entrar, pídele a un administrador que ajuste tus roles."
      action={
        <Button asChild variant="outline">
          <Link to="/mi-actividad">Ver mi sesión</Link>
        </Button>
      }
    />
  );
}

export function NotFoundPage() {
  return (
    <EmptyState
      className="mx-auto mt-24 max-w-lg"
      icon={<CompassIcon />}
      title="Esta página no existe"
      description="Revisa el enlace o vuelve al inicio de la consola."
      action={
        <Button asChild variant="outline">
          <Link to="/">Ir al inicio</Link>
        </Button>
      }
    />
  );
}
